import {Elements} from "@stripe/react-stripe-js";
import {loadStripe} from "@stripe/stripe-js";
import PaymentSection from "components/atoms/PaymentSection";
import {border} from "polished";
import React, {useEffect, useState} from "react";
import userService from "services/userService";

const stripePromise = loadStripe(
    "pk_test_51S12dMHplLHJjvu732qSRgrahDzxg5Ws0rBFRvgNnZCpZU9i1aKeTYRGZacugYAtE1ZnN0Sxh03wk9k1OCjYMPLt00YejSoXVe"
);
const Payment = () => {
//       useEffect(() => {
//     const fetchPlans = async () => {
//       try {
//         const data = await userService.getPlans();
//         // setPlans(data);
//         console.log(data, 'ata')
//       } catch (err) {
//         console.error("Error fetching plans:", err.message);
//       } finally {
//         console.log('asd')
//       }
//     };

//     fetchPlans();
//   }, []);
    // const [clientSecret, setClientSecret] = useState(null);

    // useEffect(() => {
    //     const createIntent = async () => {
    //         const stripeSecret =
    //             "sk_test_51S12dMHplLHJjvu7WaH94i4Nk6Q3FWmUWzHY9OKiRatq0D6AbRWFcJtQ6iloCkG8XXvg4SB4PPXFhpvc6fpYgKPY00n5qwojuo";

    //         const res = await fetch("https://api.stripe.com/v1/payment_intents", {
    //             method: "POST",
    //             headers: {
    //                 "Content-Type": "application/x-www-form-urlencoded",
    //                 Authorization: `Bearer ${stripeSecret}`, // Secret key
    //             },
    //             body: new URLSearchParams({
    //                 amount: "8000", // must be string
    //                 currency: "usd",
    //                 "automatic_payment_methods[enabled]": "true",
    //             }),
    //         });
    //         const data = await res.json();
    //         setClientSecret(data.client_secret);
    //     };

    //     createIntent();
    // }, []);

    // const options = {clientSecret};
    const options = {
        mode: "payment",
        currency: "usd",
        amount: 1999,
        appearance: {
            theme: "stripe",

            variables: {
                borderRadius: "12px",
                spacingGridRow: "15px",
                colorPrimary: "#313131",
            },
            rules: {
                ".Input": {
                    borderRadius: "48px",
                },
                ".Block": {
                    border: "none",
                    padding: 0,
                    boxShadow: "none",
                    paddingBottom: "10px",
                },
                ".Label": {
                    marginBottom: "10px",
                    fontWeight: 400,
                },
                ".AnimateSinglePresence": {
                    marginBottom: "10px",
                },
            },
        },
    };
    return (
        // clientSecret && (
        <Elements stripe={stripePromise} options={options}>
            <PaymentSection />
        </Elements>
        // )
    );
};

export default Payment;
